import React from "react";
import ResellerList from "./ResellerList";
import ResellerUpdate from "./ResellerUpdate";
import { Route, Switch } from "react-router-dom";
class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Switch>
          <Route
            path="/reseller/update"
            render={props => (
              <ResellerUpdate
                {...props}
                userPermissions={this.props.userPermissions}
              />
            )}
          />
          <Route
            path="/reseller/update/"
            render={props => (
              <ResellerUpdate
                {...props}
                userPermissions={this.props.userPermissions}
              />
            )}
          />
          <Route
            path="/reseller/update/:id"
            render={props => (
              <ResellerUpdate
                {...props}
                userPermissions={this.props.userPermissions}
              />
            )}
          />
          <Route
            path="/reseller"
            render={props => (
              <ResellerList
                {...props}
                userPermissions={this.props.userPermissions}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default Index;
